<template>
  <div>
    <section
      class="mobile_add_new_head bg--blue tx--bege center flex flex--content--center relative"
    >
      <div class="title">תורים שמועדם השתנה</div>
      <a
        class="m_bt_head head_alarm_close flex m-flex--center"
        href="javascript:void(0)"
        @click="$router.go(-1)"
      >
        <CloseSvg></CloseSvg>
      </a>
    </section>
    <section class="add_new_inner" v-if="pending_appointments.length > 0">
      <div class="alarm_list has--scroll">
        <div
          class="alarm_group inner_group bg--white"
          v-for="app in pending_appointments"
          :key="app.id"
        >
          <div
            class="alarm_check surgery-check flex cursor-p"
            :class="{ active: selected.indexOf(app.obj_id) > -1 }"
            @click="toggleApp(app.obj_id)"
          >
            <span class="surgery-check-ic block"></span>
            <span class="surgery-check-tx">
              <span class="block bold">
                {{ app.start_date + " " + app.start_time }}
              </span>
              {{ app.first_name + " " + app.last_name + " " + app.passport }} |
              {{ app.insurance }}
              <br />
              {{ app.phone }} | {{ app.notes }}
            </span>
          </div>
        </div>
      </div>

      <div
        v-show="selected && selected.length"
        class="alarm_btns flex flex--content--center"
      >
        <a
          class="link_blue desk-hide"
          href="javascript:void(0)"
          @click="closeMessages"
        >
          סגירת התראה
        </a>
        <a
          class="link_blue no_mobile"
          href="javascript:void(0)"
          @click="closeMessages"
        >
          סגירת התראה
        </a>
        <a class="bt_blue" href="javascript:void(0)" @click="sendMessages">
          שליחת SMS
        </a>
      </div>
    </section>
  </div>
</template>

<script>
import CloseSvg from "@/assets/img/svg/close.svg";
import { mapGetters, mapMutations } from "vuex";
import Error from "@/components/Popups/Error";
export default {
  name: "AlarmPage",
  props: ["pendingAppointments"],
  data() {
    return {
      pending: [],
      selected: [],
      pending_appointments: []
    };
  },
  mounted() {
    if (this.pendingAppointments) {
      this.pending_appointments = this.pending_appointments;
    } else {
      try {
        this.$API
          .getPendingAppointments(this.activeDoctor.id)
          .then(res => {
            let filtered = res.message;
            const sortedByTime = filtered.sort((a, b) => {
              let aa = a.start_time.substring(0, 4);
              let bb = b.start_time.substring(0, 4);
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            });
            this.pending_appointments = sortedByTime.sort((a, b) => {
              let aa = a.start_date
                .split("/")
                .reverse()
                .join();
              let bb = b.start_date
                .split("/")
                .reverse()
                .join();
              return aa < bb ? -1 : aa > bb ? 1 : 0;
            });
          })
          .catch(e => {
            this.$modal.show(Error);
          });
      } catch (e) {}
    }
  },
  methods: {
    ...mapMutations(["SET_IS_CHANGE_APP"]),
    toggleApp(id) {
      let index = this.selected.indexOf(id);
      if (index < 0) {
        this.selected.push(id);
      } else {
        this.selected.splice(index, 1);
      }
    },
    sendMessages() {
      this.sendMessagesCall(true);
    },
    closeMessages() {
      this.sendMessagesCall(false);
    },
    sendMessagesCall(send_sms) {
      if (!this.selected || !this.selected.length) return;
      this.$API
        .sendPendingAppointmentsNotifications(this.selected.join(), send_sms)
        .then(res => {
          if (!this.pendingAppointments) {
            this.$router.go(-1);
          }
          this.SET_IS_CHANGE_APP(true);
          this.$emit("close");
        })
        .catch(e => {
          this.$modal.show(Error);
        });
    }
  },
  computed: {
    ...mapGetters(["activeDoctor"])
  },
  components: {
    CloseSvg
  }
};
</script>

<style scoped></style>
